<template>
  <div class="sso-callback">
    <Spin
      v-if="!error"
      size="large"
    />
    <p v-if="!error">
      {{ $t("Signing you in…") }}
    </p>
    <div
      v-else
      class="sso-error"
    >
      <p>{{ $t("Microsoft sign-in failed. Please try again or use email/password.") }}</p>
      <router-link :to="{ name: 'login' }">
        {{ $t("Back to login") }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { getAccountQry } from "../../services/auth.service";
import { setAuthSession } from "../../helpers/auth.helper";

export default {
  name: "SsoCallback",
  data() {
    return { error: false };
  },
  created() {
    this.handleCallback();
  },
  methods: {
    parseFragment() {
      // Backend sends the token in the URL fragment: #access_token=...&refresh_token=...
      const raw = (window.location.hash || "").replace(/^#/, "");
      const params = {};
      raw.split("&").forEach((pair) => {
        if (!pair) return;
        const [k, v] = pair.split("=");
        params[decodeURIComponent(k)] = decodeURIComponent(v || "");
      });
      return params;
    },
    async handleCallback() {
      const params = this.parseFragment();

      if (params.sso_error || !params.access_token) {
        this.error = true;
        return;
      }

      try {
        // Same session-building flow as the password login: token + /api/account/.
        const account = await getAccountQry({}, params.access_token);
        const sessionToSave = Object.assign(
          {
            access_token: params.access_token,
            refresh_token: params.refresh_token,
            expires_in: params.expires_in,
            token_type: params.token_type || "Bearer",
          },
          account.data
        );
        setAuthSession(sessionToSave);
        // Clean the token out of the URL, then enter the app.
        window.history.replaceState({}, document.title, window.location.pathname);
        this.$router.push({ name: "map" });
      } catch (e) {
        this.error = true;
      }
    },
  },
};
</script>

<style scoped>
.sso-callback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 16px;
}
.sso-error {
  text-align: center;
  color: #c0392b;
}
</style>
